import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMailchimpComponent } from './simple-icons-mailchimp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMailchimpComponent ],
    exports:      [ SimpleIconsMailchimpComponent ],
    bootstrap:    []
})
export class SimpleIconsMailchimpModule {}
